export enum FilterCode {
    BookingFeature = 'BookingFeature',
    SubCategory = 'SubCategory',
    PointOfInterest = 'PointOfInterest',
    ActivityContent = 'ActivityContent',
    ReviewWithImage = 'ReviewWithImage',
    ReviewSource = 'ReviewSource',
    ActivityId = 'ActivityId',
    Category = 'Category',
    Supplier = 'Supplier',
    Duration = 'Duration',
    Rating = 'Rating',
    Price = 'Price',
}
